import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "counter"]

  connect() {
    this.currentPage = 1
    this.totalPages = this.previewTargets.length
    this.showPage(this.currentPage)
  }

  previous() {
    if (this.currentPage > 1) {
      this.currentPage--
      this.showPage(this.currentPage)
    }
  }

  next() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
      this.showPage(this.currentPage)
    }
  }

  showPage(page) {
    this.previewTargets.forEach(el => {
      el.classList.toggle("d-none", el.dataset.page != page)
    })

    this.counterTarget.textContent = `${page} of ${this.totalPages}`
    this.element.querySelector('[data-action="invoice-preview#previous"]').disabled = page === 1
    this.element.querySelector('[data-action="invoice-preview#next"]').disabled = page === this.totalPages

    this.setActivePreviewPage(page)
  }

  setActivePreviewPage(page) {
    const hiddenField = this.element.querySelector("#preview-page")
    if (hiddenField) hiddenField.value = page
  }
}
